import $ from "jquery";
import { Controller } from "@hotwired/stimulus";
import CommonController from "./common_controller";

export default class extends Controller {
  windowWidth = $(window).width();
  breakpoint = 768; // ブレークポイントを768pxに設定
  static targets = ["globalNav", "globalNavButton", "globalNavButtonText", "headerMenuButton", "headerNavButtonText"];

  connect() {
    window.addEventListener("resize", this.handleResize);
    this.commonController = new CommonController();
  }

  disconnect() {
    window.removeEventListener("resize", this.handleResize);
    if (this.windowWidth < this.breakpoint) {
      // 画面を離れた時、SPの状態をリセット
      $(this.globalNavTarget).hide().removeClass("is-open");
      this.headerMenuButtonTarget.classList.remove("is-open");
      this.globalNavButtonTextTarget.textContent = "メニューを開く";
      this.headerNavButtonTextTarget.textContent = "を開く";
    } else {
      // 画面を離れた時、PCの状態をリセット
      this.menuOpenPc();
    }
  }

  handleResize = () => {
    const newWindowWidth = window.innerWidth;
    const isDrawerOpen = $(".js-drawer").hasClass("is-open");
    const isModalOpen = $(".js-modal").hasClass("is-open");

    if (this.windowWidth >= this.breakpoint && newWindowWidth < this.breakpoint) {
      // PCからSPに切り替わる時、PC用の状態をリセット
      $(this.globalNavTarget).hide();
      this.globalNavTarget.classList.remove("is-min");
      this.globalNavButtonTarget.setAttribute("aria-expanded", "false");
    } else if (this.windowWidth < this.breakpoint && newWindowWidth >= this.breakpoint) {
      // SPからPCに切り替わる時、SPの状態をリセット
      $(this.globalNavTarget).show();
      this.globalNavTarget.classList.remove("is-open");
      this.globalNavButtonTextTarget.textContent = "メニューを閉じる";
      this.headerMenuButtonTarget.classList.remove("is-open");
      this.headerNavButtonTextTarget.textContent = "を開く";

      // 開いているモーダル・ドロワーがある時は除外
      if (!isDrawerOpen && !isModalOpen) {
        this.commonController.HtmlScroll();
      }

      this.globalNavButtonTarget.setAttribute("aria-expanded", "true");
    }
    // 新しい画面幅を記録
    this.windowWidth = newWindowWidth;
  };

  // ボタンクリックでメニューを開閉
  action() {
    if (this.windowWidth < this.breakpoint) {
      // SP
      if (this.globalNavTarget.classList.contains("is-open")) {
        this.menuCloseSp();
      } else {
        this.menuOpenSp();
      }
    } else {
      // PC
      if (this.globalNavTarget.classList.contains("is-min")) {
        this.menuOpenPc();
      } else {
        this.menuClosePc();
      }
    }
  }

  // SP メニューを開く処理
  menuOpenSp() {
    $(this.globalNavTarget).show().addClass("is-open");
    this.headerMenuButtonTarget.classList.add("is-open");
    this.globalNavButtonTextTarget.textContent = "メニューを閉じる";
    this.headerNavButtonTextTarget.textContent = "を閉じる";
    this.commonController.HtmlFix();
  }
  // SP メニューを閉じる処理
  menuCloseSp() {
    $(this.globalNavTarget).stop().removeClass("is-open").fadeOut(300);
    this.headerMenuButtonTarget.classList.remove("is-open");
    this.globalNavButtonTextTarget.textContent = "メニューを開く";
    this.headerNavButtonTextTarget.textContent = "を開く";
    this.commonController.HtmlScroll();
  }

  // PC メニューを開く処理
  menuOpenPc() {
    this.globalNavTarget.classList.remove("is-min");
    this.globalNavButtonTarget.setAttribute("aria-expanded", "true");
    this.globalNavButtonTextTarget.textContent = "メニューを閉じる";
    this.headerNavButtonTextTarget.textContent = "を閉じる";
  }
  // PC メニューを閉じる処理
  menuClosePc() {
    this.globalNavTarget.classList.add("is-min");
    this.globalNavButtonTarget.setAttribute("aria-expanded", "false");
    this.globalNavButtonTextTarget.textContent = "メニューを開く";
    this.headerNavButtonTextTarget.textContent = "を開く";
  }
}
